import {
  AcceptInviteDto,
  CreateInviteDto,
  InviteDto,
  InviteStatusDto,
  UpdateInviteDto,
} from "@repo/api/invite";
import { AmplifilesClient } from "./api-client";

export class InviteApi {
  static async acceptInvite(inviteExternalId: string) {
    const response = await AmplifilesClient.instance.post(
      `/invite/${inviteExternalId}/accept`,
    );
    return AcceptInviteDto.parse(response.data);
  }

  static async getInviteStatus(inviteExternalId: string) {
    const response = await AmplifilesClient.instance.get(
      `/invite/${inviteExternalId}/status`,
    );
    return InviteStatusDto.parse(response.data);
  }

  static async createInvite(data: CreateInviteDto, teamExternalId: string) {
    const response = await AmplifilesClient.instance.post(
      `/team/${teamExternalId}/invite`,
      data,
    );
    return InviteDto.parse(response.data);
  }

  static async updateInvite(
    data: UpdateInviteDto,
    teamExternalId: string,
    inviteExternalId: string,
  ) {
    const response = await AmplifilesClient.instance.post(
      `/team/${teamExternalId}/invite/${inviteExternalId}/update`,
      data,
    );
    return InviteDto.parse(response.data);
  }

  static async deleteInvite(inviteExternalId: string, teamExternalId: string) {
    const response = await AmplifilesClient.instance.post(
      `/team/${teamExternalId}/invite/${inviteExternalId}/delete`,
    );
    return InviteDto.parse(response.data);
  }
}
